module.exports = require("react-currency-format");